import React from 'react'
import logo from '../../assets/logo.svg'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom'

class AuthHeader extends React.PureComponent {
  render() {
    return(
      <div className="inner">
          <Grid container spacing={0} justify="center">
            <Grid item xs={12} md={4}>
              <Paper className="no-boxshadow">
                <h2 className="logo ta-center">
                  <Link to="/">
                    <img src={logo} alt="" />
                  </Link>
                </h2>
              </Paper>
            </Grid>
          </Grid>
        </div>
      // <div className="mdc-layout-grid mdc-instalevel-grid no-pb-padding">
      //   <div className="mdc-layout-grid__inner">
      //     <div className="mdc-layout-grid__cell grid-centered">

      //     </div>
      //   </div>
      // </div>
    )
  }
}

export default AuthHeader



// WEBPACK FOOTER //
// ./src/js/components/AuthHeader.js